import { render } from "./cart-preview.vue?vue&type=template&id=cbd0c948&scoped=true&lang=pug"
import script from "./cart-preview.vue?vue&type=script&lang=js"
export * from "./cart-preview.vue?vue&type=script&lang=js"

import "./cart-preview.vue?vue&type=style&index=0&id=cbd0c948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd0c948"]])

export default __exports__